export enum INTEGRATION_COLLAPSES {
    WORKFLOW = "workflow",
    CUSTOM_FIELDS = "custom_fields",
    ACTIVEUSER = "active_user",
    DEFAULTUSER = "default_user",
}
export interface INTEGRATION_Data {
    worflows: any[],
    custom_fields: any[],
}